import React, { useEffect, useState } from 'react';

import { Box, Tabs, Tab, useTheme } from '@mui/material';

import CustomImageComponent from '@/components/shared/custom/custom-image';
import { getCompetitionImage, getCompetitionName } from '@/helpers/leagues-helper';

const MinutesActionsTabsPlayerComponent = ({ partidos, selectedLeague, setSelectedLeague }) => {
    const theme = useTheme();
    const [leagues, setLeagues] = useState([]);

    useEffect(() => {
        const leagueSet = new Set();
        partidos?.forEach((partido) => {
            leagueSet.add(partido.leagueId);
        });

        setLeagues(['all', ...Array.from(leagueSet)]);
    }, [partidos]);

    return (
        <Box
            sx={{
                width: '100%',
                borderBottom: 1,
                borderColor: 'divider',
                mb: 1,
            }}
        >
            <Tabs
                value={selectedLeague}
                onChange={(_, newValue) => setSelectedLeague(newValue)}
                variant="scrollable"
                scrollButtons="auto"
                sx={{
                    '& .MuiTabs-flexContainer': {
                        justifyContent: 'flex-start',
                    },
                    '& .MuiTabs-indicator': {
                        backgroundColor: theme.palette.primary.main,
                        height: 3,
                        borderRadius: '3px 3px 0 0',
                    },
                }}
            >
                {leagues.map((leagueId) => (
                    <Tab
                        key={leagueId}
                        value={leagueId}
                        sx={{
                            textTransform: 'none',
                            minWidth: 'auto',
                            px: 0.5, // 4px padding horizontal
                            py: 1.5,
                            fontSize: '0.875rem',
                            fontWeight: 500,
                            color: theme.palette.text.secondary,
                            transition: 'all 0.2s ease-in-out',
                            '&:hover': {
                                color: theme.palette.primary.main,
                                backgroundColor: 'transparent',
                            },
                            '&.Mui-selected': {
                                color: theme.palette.primary.main,
                                fontWeight: 600,
                            },
                        }}
                        label={
                            <Box
                                sx={{
                                    display: 'flex',
                                    alignItems: 'center',
                                    gap: 0.5,
                                }}
                            >
                                {leagueId !== 'all' && (
                                    <CustomImageComponent
                                        src={getCompetitionImage(leagueId)}
                                        alt={getCompetitionName(leagueId)}
                                        width={20}
                                        height={20}
                                    />
                                )}
                                {leagueId === 'all' && 'Todas'}
                            </Box>
                        }
                    />
                ))}
            </Tabs>
        </Box>
    );
};

export default MinutesActionsTabsPlayerComponent;
